import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Paragraph } from "components/Paragraph";
import { Spinner } from "components/Spinner";
import { homePath, productsPath } from "constants/routes";
import { usePunchout } from "contexts/PunchoutProvider";
import { useLayout } from "hooks/useLayout";
import { useMe } from "hooks/useMe";
import {
  API,
  removeAuthenticationHeader,
  setAuthenticationHeader,
} from "utils/api";
import { removeToken, setToken } from "utils/cookies";

interface PunchoutSessionData {
  token: string;
}

export const PunchoutLaunch = () => {
  const navigate = useNavigate();
  const { refetch: forceRefetchMe } = useMe({ skip: true });
  const { token } = useParams<{ token: string }>();
  const { setIsPunchoutSession } = usePunchout();
  const { PublicLayout } = useLayout({ title: "Iniciando Sesión" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const resolvePunchoutSession = async () => {
      if (!token) {
        setError("No se proporcionó token de redirección");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await API.post<PunchoutSessionData>(
          `/punchout/resolve/${token}`
        );
        const sessionData: PunchoutSessionData = response.data;
        setToken({ token: sessionData.token });
        setAuthenticationHeader({ token: sessionData.token });
        setIsPunchoutSession(true);
        navigate(productsPath);
        forceRefetchMe();
      } catch (err) {
        console.error("Error resolving punchout session:", err);
        setError("Sesión inválida o expirada.");
        removeToken();
        removeAuthenticationHeader();
        setLoading(false);
      }
    };

    resolvePunchoutSession();
  }, [token, navigate, setIsPunchoutSession, forceRefetchMe]);

  if (loading) {
    return (
      <PublicLayout>
        <Box sx={{ minHeight: "100vh" }}>
          <Spinner />
        </Box>
      </PublicLayout>
    );
  }

  if (error) {
    return (
      <PublicLayout>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2,
          }}
        >
          <Paragraph font="l" style={{ fontSize: "2rem" }}>
            ⚠️
          </Paragraph>
          <Paragraph font="xl" style={{ fontWeight: "bold" }}>
            Error de Sesión
          </Paragraph>
          <Paragraph
            font="md"
            style={{ textAlign: "center", color: "text.secondary" }}
          >
            {error}
          </Paragraph>
          <Button
            variant="contained"
            onClick={() => navigate(homePath)}
            sx={{ mt: 2 }}
          >
            Volver al Inicio
          </Button>
        </Box>
      </PublicLayout>
    );
  }

  return null;
};
